var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7899 0C63.2144 0 81.4204 18.1424 81.4204 40.4887C81.4204 62.8349 63.2144 80.9773 40.7899 80.9773C18.3654 80.9773 0.159424 62.8349 0.159424 40.4887C0.159424 18.1424 18.3654 0 40.7899 0ZM65.1229 28.3069C64.5389 26.1293 62.8181 24.4147 60.633 23.8326C56.6718 22.7749 40.7899 22.7749 40.7899 22.7749C40.7899 22.7749 24.908 22.7749 20.9468 23.8326C18.7622 24.4147 17.0409 26.1293 16.4568 28.3069C15.3959 32.2538 15.3959 40.489 15.3959 40.489C15.3959 40.489 15.3959 48.7238 16.4568 52.6704C17.0409 54.8481 18.7622 56.5633 20.9468 57.1451C24.908 58.2024 40.7899 58.2024 40.7899 58.2024C40.7899 58.2024 56.6718 58.2024 60.633 57.1451C62.8181 56.5633 64.5389 54.8481 65.1229 52.6704C66.1839 48.7238 66.1839 40.489 66.1839 40.489C66.1839 40.489 66.1839 32.2538 65.1229 28.3069ZM35.7109 48.0807V32.8972L48.9058 40.489L35.7109 48.0807Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6195a3e003e3bf88f9d02b3f29157d7c.svg";
export { ForwardRef as ReactComponent };